import React from 'react';
import { Route } from 'react-router-dom';
import AdminTab from '../../components/AdminTab';
import DashboardWrap from '../../components/DashboardWrap';
import { AdminRouteName } from '../CONSTANTS';
import Styles from './AdminSettings.module.scss';
import RolesAndPermission from './RolesAndPermission';
import UserManagement from './UserManagement';

const AdminSettings = () => {
  const Tabs: any = [
    { name: 'Roles and permissions', link: '/settings' },
    {
      name: 'User management', link: '/settings/user-management',
    },
  ];
  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__tab}><AdminTab tabs={Tabs} /></div>
        <Route exact path={AdminRouteName.settingsRoute}>
          <RolesAndPermission />
        </Route>
        <Route path={AdminRouteName.settingsTeamMemberRoute}>
          <UserManagement defaultUrl={AdminRouteName.settingsTeamMemberRoute} hasNameAndImage toggleStorageId="all_user-management-table-col" />
        </Route>
      </div>

    </DashboardWrap>

  );
};

export default AdminSettings;
